import { useQuery } from './use-query';
import type { Submission } from '../types';

export const useSubmissions = (filters: URLSearchParams) => {
  const { data, error, isLoading } = useQuery<Submission[]>(`/submissions?${filters}`);

  return {
    data,
    error,
    isLoading,
  };
};
